type UseBelowElementOptions = {
  getScrollY?: () => number
}

export const useBelowElement = (options: UseBelowElementOptions = {}) => {
  const height = 80
  const isBelow = ref(false)

  const getScrollY =
    options.getScrollY ?? (() => (import.meta.client ? window.scrollY : 0))

  const updateElementHeight = () => {
    if (!import.meta.client) return
  }

  const updateIsBelow = () => {
    if (!import.meta.client) return
    isBelow.value = getScrollY() > height
  }

  const sync = async () => {
    await nextTick()
    updateElementHeight()
    updateIsBelow()
  }

  onMounted(() => {
    void sync()
    window.addEventListener('scroll', updateIsBelow, { passive: true })
    window.addEventListener('resize', sync)
  })

  onUnmounted(() => {
    window.removeEventListener('scroll', updateIsBelow)
    window.removeEventListener('resize', sync)
  })

  return {
    isBelow,
    updateElementHeight,
    updateIsBelow,
    sync
  }
}
